export const styles = {
  container: 'tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-8',
  spinner: 'tw-text-primary-600 tw-mb-3',
  label: 'tw-text-sm tw-text-neutral-500',
};
